export default __webpack_public_path__ + "static/media/calendar.847853d9.png";